/** The captured tray (unit convention §1); `side` is the discriminator prop. */
import React from 'react';

import type {Side} from '@/Store/liveGame/state';

import {useCapturedModel} from './model';
import CapturedView from './View';

export default React.memo(function Captured({side}: {side: Side}) {
  return <CapturedView side={side} {...useCapturedModel(side)} />;
});
